import React from "react";
import ReactDOM from "react-dom";
import "babel-polyfill";
import Hoc from "./Hoc";
import { HashRouter } from "react-router-dom";

ReactDOM.render(
  <HashRouter>
    <Hoc />
  </HashRouter>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js